import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconSound = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='30'
            viewBox='0 0 30 30'
            width='30'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M19.7837 15.9375V14.0625H24.3028V15.9375H19.7837ZM21.2115 24.3509L17.5962 21.6394L18.7356 20.1444L22.3509 22.8556L21.2115 24.3509ZM18.6875 9.8078L17.5481 8.31248L21.1634 5.60092L22.3028 7.09624L18.6875 9.8078ZM4.44717 18.125V11.875H9.08655L14.4472 6.51467V23.4853L9.08655 18.125H4.44717Z'
                fill={fill}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconSound;
